module.exports = __webpack_public_path__ + "static/media/dog.edaa1dc7.jpg";